<ng-container
  *ngIf="row && item && item.actionBtn && item.actionBtn.length > 0"
>
  <div class="d-flex flex-row justify-content-center">
    <ng-container *ngFor="let key of item.actionBtn">
      <ng-container *ngIf="key == ACTION_EVENT.VIEW">
        <button matTooltip="View" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
            src="/assets/view_icon.svg"
            alt="action-button-icon"
            class="actionbtnImg"
          />
        </button>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT_HANDLER.REPORT && (item.isReport || userDetail.usr_role_track_id == '2')">
        <button matTooltip="View Report" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
          src="assets/menu-icon/reports.svg"
          alt="View Report"
          class="actionbtnImg"
        />
        </button>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT.MOREOPTION">
        <button matTooltip="More Options" mat-icon-button [matMenuTriggerFor]="menu" class="action-btn">
          <mat-icon style="font-size: 20px;" class="actionbtnImg">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" yPosition="below">
            <ng-container *ngFor="let btn of item.actionBtnMoreOptions">
              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.REQUEST_QUOTATION">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/quotation_icon.svg" class="more_icon_images" alt="quotation_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.VIEW_RATINGS">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/reviews_icon.svg" class="more_icon_images" alt="phone_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>
              
              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.SCHEDULE_CALL">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/phone_call.svg" class="more_icon_images" alt="phone_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.MESSAGE">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/message_icon.svg" class="more_icon_images" alt="message_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.EMAIL">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/email_icon.svg" class="more_icon_images" alt="email_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.MAKE_APPOINTMENT">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/appointment.svg" class="more_icon_images" alt="appointment_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.VIEW">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/view_icon.svg" class="more_icon_images" alt="view_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.EDIT">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/edit_icon.svg" class="more_icon_images" alt="edit_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.SHARE">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/share_icon.svg" class="more_icon_images" alt="share_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.BOOKMARK">
                <ng-container *ngIf="row[btn.keyname] == '1'; else addBookmark">
                  <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                    <img src="/assets/star_icon.svg" class="more_icon_images" alt="star_icon">
                    <span>{{btn.label2}}</span>
                  </button>
                </ng-container>
                <ng-template #addBookmark>
                  <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                    <img src="/assets/bookmark_icon.svg" class="more_icon_images" alt="bookmark_icon">
                    <span>{{btn.label}}</span>
                  </button>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.DOWNLOAD">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/download_icon.svg" class="more_icon_images" alt="download_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>
              
              <ng-container *ngIf="btn.value == ACTION_EVENT_HANDLER.DELETE">
                <button mat-menu-item type="button" (click)="click(i, item.type, btn.value)">
                  <img src="/assets/del_icon.svg" class="more_icon_images" alt="delete_icon">
                  <span>{{btn.label}}</span>
                </button>
              </ng-container>
            </ng-container>
        </mat-menu>
      </ng-container>
      <ng-container *ngIf="(row.status !== ACTION_EVENT.APPROVED && row.status !== ACTION_EVENT.COMPLETE && row.status !== ACTION_EVENT.PAID && row.status !== ACTION_EVENT.REJECTED && row.status !== ACTION_EVENT.CLOSED && row.status !== ACTION_EVENT.CANCELED && row.status !== ACTION_EVENT.ACCEPT && row.status !== ACTION_EVENT.DECLINE && row.status !== ACTION_EVENT.COMPLETED) || item.isStatusCheckFalse">
        <!--organiser is used in events instead of user_id-->
        <ng-container *ngIf="key == ACTION_EVENT_HANDLER.EDIT && (item.isEdit || row.user_id == userDetail.user_id || row.organiser == userDetail.user_id)">
          <button matTooltip="Edit" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
            <img
              src="/assets/edit_icon.svg"
              alt="action-button-icon"
              class="actionbtnImg"
            />
          </button>
        </ng-container>
        <ng-container *ngIf="key == ACTION_EVENT_HANDLER.COPY && item.isCopy">
          <button matTooltip="Copy as new task" mat-icon-button type="button" class="action-btn" (click)="click(i, item.type, key)">
            <mat-icon class="actionbtnImg" style="font-size: 22px;">content_copy</mat-icon>
          </button>
        </ng-container>
       
        <ng-container *ngIf="key == ACTION_EVENT_HANDLER.CANCEL && (item.isCancel || row.user_id == userDetail.user_id)">
          <button matTooltip="Cancel" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
            <img
              src="/assets/cancel.svg"
              alt="action-button-icon"
              class="actionbtnImg"
            />
          </button>
        </ng-container>
        <ng-container *ngIf="key == ACTION_EVENT_HANDLER.ACCEPT && (item.isAccept || row.user_id == userDetail.user_id)">
          <button matTooltip="Accept" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
            <img
              src="/assets/accept.svg"
              alt="action-button-icon"
              class="actionbtnImg"
            />
          </button>
        </ng-container>
        <ng-container *ngIf="key == ACTION_EVENT_HANDLER.ASSIGN_JOB && row.status !== ACTION_EVENT.ASSIGNED  && (item.isAssignJob || row.user_id == userDetail.user_id)">
          <button matTooltip="Reassign" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
            <img
              src="/assets/assign_job.svg"
              alt="action-button-icon"
              class="actionbtnImg"
            />
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT_HANDLER.GEN_INVOICE && (item.isGenInvoice || row.user_id == userDetail.user_id)">
        <button matTooltip="Generate" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
            src="/assets/generate_invoice.svg"
            alt="action-button-icon"
            class="actionbtnImg"
          />
        </button>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT_HANDLER.UPLOAD && (item.isUpload || row.user_id == userDetail.user_id)">
        <button matTooltip="Upload" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
            src="/assets/upload_invoice.svg"
            alt="action-button-icon"
            class="actionbtnImg"
          />
        </button>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT_HANDLER.DELETE && (item.isDelete || row.user_id == userDetail.user_id && row.status !== ACTION_EVENT.COMPLETED )">
        <button matTooltip="Delete" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
            src="/assets/del_icon.svg"
            alt="action-button-icon"
            class="actionbtnImg"
          />
        </button>
      </ng-container>
      <ng-container *ngIf="key == ACTION_EVENT_HANDLER.SCHEDULE_CALL && row && row.contact_number">
        <button matTooltip="Schedule Call" mat-icon-button class="action-btn" (click)="click(i, item.type, key)">
          <img
            src="/assets/phone_call.svg"
            alt="action-button-icon"
            class="actionbtnImg"
          />
        </button>
      </ng-container>
   
    </ng-container>
  </div>
</ng-container>
